import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { UploadDataType, UploadManagementSchema } from '../../_offline/models/upload-management.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class UploadManagementDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(tenantId: string, userId: string, type?: UploadDataType, parentId?: string, isUnUploadOnly?: boolean)
    : Observable<UploadManagementSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.GET_ALL, tenantId, userId, type, parentId, isUnUploadOnly);
  }

  get(tenantId: string, userId: string, dataId: string, type: UploadDataType): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.GET, tenantId, userId, type, dataId);
  }

  putAll(schemas: UploadManagementSchema[]): Observable<UploadManagementSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.PUT_ALL, schemas);
  }

  put(schema: UploadManagementSchema): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.PUT, schema);
  }

  uploaded(dataId: string, type: UploadDataType): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.UPLOADED, type, dataId);
  }

  deleted(dataId: string, type: UploadDataType): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.DELETE, type, dataId);
  }

  deletedList(dataIds: string[], type: UploadDataType): Observable<boolean> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.DELETE_LIST, type, dataIds);
  }

  deletedByParentId(parentId: string, type: UploadDataType, isLogicalDelete = true): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.DELETE_BY_PARENT_ID, type, parentId, isLogicalDelete);
  }

  deletedRelatedDataId(parentId: string, isLogicalDelete = true): Observable<UploadManagementSchema> {
    return this.ipcSendSync(IPC_CHANNEL.UPLOAD_MANAGE.DELETE_RELATED_ID, parentId, isLogicalDelete);
  }
}
